/**
 * Datos mock para la sección Works
 * En el futuro se migrará a i18n para internacionalización
 */

import hyperdriveLogo from '@/assets/images/works/projects/hyperdrive/hyperdrive-logo.png'
import braillihubLogo from '@/assets/images/works/milo-13--braillihub.png'
import miloLogo from '@/assets/images/works/milo-05--braillihub.png'
import hogarflowLogo from '@/assets/images/works/hogarflow-logo-v1.svg'
import tbetLogo from '@/assets/images/works/tbet-logo.png'
import caLogo from '@/assets/images/works/c&a-logo.png'
import simplifyLogo from '@/assets/images/works/simplify-logo.png'
import shuryLogo from '@/assets/images/works/shury-image-profile-assistant.png'
import firmameshLogo from '@/assets/images/works/projects/firmamesh/firmamesh-logo.svg'

export const worksData = [
  {
    id: 'ultra-instinct',
    title: 'Ultra Instinct Theme',
    category: 'VS Code Extension',
    year: '2026',
    icon: 'https://raw.githubusercontent.com/juanlias/ultra-instinct-theme/master/images/icon.png',
    src: 'https://images.unsplash.com/photo-1629654297299-c8506221ca97?q=80&w=1920&auto=format&fit=crop',
    description:
      'A neurodivergent-designed VS Code theme trilogy built to eliminate visual noise and achieve deep focus and flow state.',
    tech: ['VS Code', 'JSON', 'TypeScript', 'VSIX'],
    link: 'https://ultrainstincttheme.com/',
    userCase: {
      challenge:
        'Design a VS Code theme trilogy that eliminates sensory overload for neurodivergent developers while maintaining full WCAG 2.1 AA compliance.',
      metrics: [
        { value: 'v0.1.3', label: 'Version' },
        { value: '37+', label: 'Marketplace' },
        { value: '2K+', label: 'Open VSX' },
      ],
    },
  },
  {
    id: 'firmamesh',
    title: 'Firmamesh',
    category: 'Gradientes atmosféricos de nuestro hermoso planeta',
    role: 'Product Design Engineer & Front-End Engineer',
    year: '2026',
    icon: firmameshLogo,
    description:
      'Reúne 141 paisajes atmosféricos reales de 75 países, con 5 momentos del día usando OKLCH para transiciones de color vivas. El slider recorre el arco solar completo — desde el nadir hasta el cenit — con sol, luna y estrellas en tiempo real, fase lunar astronómica. Permite copiar el gradiente como CSS, exportar SVG para Figma o descargar imagen en alta resolución. Incluye editor de capas atmosféricas con control fino de luminosidad, croma y matiz. Construido con React 19 + Vite 6 + Tailwind v4, 100% offline.',
    tech: ['React 19', 'Tailwind v4', 'OKLCH', 'SVG'],
    link: 'https://firmamesh.com',
    showModal: true,
    noCaseStudy: false,
  },

  {
    id: 'braillihub',
    title: 'Braillihub',
    category: 'Accessibility Tool',
    year: '2026',
    icon: braillihubLogo,
    description:
      'A space to explore the languages that connect people, beyond words. Translate text to Braille, Morse Code, or Caesar Cipher — and explore each with interactive tools designed for curiosity.',
    tech: ['Vue 3', 'Tailwind', 'Web Audio API', 'WCAG AAA'],
    link: 'https://braillihub.com/',
    userCase: {
      challenge:
        'Build an accessible, high-contrast (WCAG AAA) educational platform that makes communication systems like Braille, Morse Code, and Caesar Cipher explorable through interactive, hands-on tools.',
      metrics: [
        { value: 'WCAG AAA', label: 'Accessibility' },
        { value: '3', label: 'Languages' },
        { value: '2025', label: 'Year' },
      ],
    },
  },

  {
    id: 'milo',
    title: 'Milo',
    category: 'Brand Character',
    year: '2026',
    icon: miloLogo,
    description:
      "Milo is Braillihub's brand character — a curious little explorer who believes every language deserves to be understood. He's here to embody the spirit of discovery and keep you company while you explore Braille, Morse, and beyond.",
    tech: ['Figma', 'Illustration', 'Character Design'],
    showModal: true,
    userCase: {
      challenge:
        'Create a warm, approachable mascot that embodies the spirit of Braillihub — curiosity, discovery, and making language exploration feel safe and fun for everyone.',
      metrics: [
        { value: 'Mascot', label: 'Role' },
        { value: '2025', label: 'Year' },
        { value: 'Braillihub', label: 'Platform' },
      ],
    },
  },
  {
    id: 'hyperdrive',
    title: 'Hyperdrive',
    category: 'Web Portfolio',
    year: '2024',
    icon: hyperdriveLogo,
    description:
      'A stunning portfolio website with a hyperspace travel animation built with Vue 3 and featuring smooth GSAP transitions.',
    tech: ['Vue 3', 'GSAP', 'Tailwind', 'Canvas', 'i18n'],
    link: 'https://hyperdrive.juanlias.com/',
    userCase: {
      challenge:
        'Create an immersive sci-fi experience with complex animations (hyperspace, holographic effects) while maintaining high performance and accessibility.',
      metrics: [
        { value: '60fps', label: 'Animation' },
        { value: '4', label: 'Languages' },
        { value: '98/100', label: 'Performance' },
      ],
    },
  },
]

export const inProgressData = [
  {
    id: 'hogarflow',
    title: 'HogarFlow',
    category: 'Home Command Center',
    year: '2025',
    icon: hogarflowLogo,
    description:
      'HogarFlow is a smart home platform that centralizes finances, shopping, tasks, and routines in one place — designed so users stop managing and start living, with Shury as the AI assistant that handles it all.',
    tech: ['Vue 3', 'Tailwind', 'Supabase', 'Figma'],
    link: 'https://hogarflow.com/',
    moreInfo: true,
  },
  {
    id: 'shury',
    title: 'Shury L1',
    category: 'AI HogarFlow Assistant',
    year: '2025',
    icon: shuryLogo,
    description:
      "Shury is HogarFlow's AI assistant — she handles finances, tasks, notes, subscriptions, and takes care of home errands on behalf of the user, so they can live with calm and control.",
    tech: ['Gemini', 'FastAPI', 'Supabase', 'Vue 3', 'Tailwind'],
    link: null,
    moreInfo: true,
  },
]

export const otherProjects = [
  {
    id: 'tbet',
    name: 'TBet Sports Bettings',
    role: 'Product Designer · UI/UX Lead & Frontend Engineer',
    duration: '4+ years · 2017–2022',
    description:
      'Led the UI/UX department at Katavi Gaming Limited (Tanzania) — user research, design system, wireframes, and accessibility-focused UI for users with older devices. I also owned the frontend implementation. Followed the full product development cycle under SCRUM/Jira, and collaborated with marketing on corporate identity and social media visuals.',
    tech: ['HTML', 'CSS', 'JavaScript', 'Figma', 'Design System', 'SCRUM', 'Jira', 'Brand Design'],
    url: null,
    logo: tbetLogo,
  },
  {
    id: 'cassian',
    name: 'Cassian & Associates',
    role: 'Brand Identity, UI/UX Design & Full-Stack Dev',
    duration: '3 months · 2023',
    description:
      'Full rebrand and website refresh for a certified public accounting & tax consultancy firm in Tanzania (Dar es Salaam & Arusha) — visual identity overhaul, complete site redesign, from concept to deployment.',
    tech: ['Vue 3', 'GSAP', 'Lenis', 'Tailwind', 'Figma', 'Supabase', 'Brand Design'],
    url: 'https://cassian.co.tz/',
    logo: caLogo,
    caseStudy: true,
  },
  {
    id: 'simplify-vfd',
    name: 'Simplify VFD',
    role: 'Art Director · Product Designer & Frontend Engineer',
    duration: '20 months · 2020–2022',
    description:
      'At Simplitech Limited (Tanzania), I led product design end-to-end — competitor research, brand identity, MVP scoping, and high-fidelity interfaces. I also owned the entire frontend and all API integrations, and co-designed the marketing visual system.',
    tech: ['Vue 3', 'Quasar', 'Composition API', 'Adobe XD', 'Figma', 'Brand Design', 'Jira'],
    url: 'https://simplify.co.tz/',
    logo: simplifyLogo,
    caseStudy: true,
  },
]
